// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"51fb321b","513":"298607b9","703":"522f25c5"}[chunkId] + ".chunk.js";
};